import {createRoot} from 'react-dom/client';
import App from './App.jsx';
import './index.css';

if (import.meta.env.DEV) {
  window.addEventListener('error',(event)=> console.error('Global error captured:',event.error || event.message));
  window.addEventListener('unhandledrejection',(event)=> console.error('Unhandled promise rejection:',event.reason));
}

let serviceWorkerRegistration=null;

const captureServiceWorkerRegistration=async ()=> {
  if (!('serviceWorker' in navigator)) return null;
  try {
    serviceWorkerRegistration=await navigator.serviceWorker.ready;
    return serviceWorkerRegistration;
  } catch (error) {
    console.warn('PWA service worker registration unavailable:',error);
    return null;
  }
};

const checkForAppUpdate=async ()=> {
  if (!('serviceWorker' in navigator) || navigator.onLine===false) return;
  const registration=serviceWorkerRegistration || await captureServiceWorkerRegistration();
  if (!registration) return;
  registration.update().catch(error=> console.warn('App update check failed:',error));
};

if ('serviceWorker' in navigator) {
  window.addEventListener('load',()=> {
    captureServiceWorkerRegistration();
  });
  window.setInterval(checkForAppUpdate,30*60*1000);
  window.addEventListener('online',checkForAppUpdate);
  window.addEventListener('focus',checkForAppUpdate);
  document.addEventListener('visibilitychange',()=> {
    if (document.visibilityState==='visible') checkForAppUpdate();
  });
}

createRoot(document.getElementById('root')).render(<App />);